import { i18nClient } from '@sailor/i18n-mach-pro'
import commonRequest from '@/common/api'
import { isJSON } from '@/common/utils'

const ActivityIndicator = Mach.requireModule('ActivityIndicator')
const Toast = Mach.requireModule('Toast')

type RequestVo = {
  code: number
  message: string
  data: any
}

type OptionsVo = {
  returnAll?: boolean // 成功全量数据返回，使用此参数，下列参数失效
  errorToast?: boolean // 是否展示错误toast
  errorMsg?: string // 错误toast文案
  loading?: boolean // 是否展示请求loading
  onSuccess?: (data: RequestVo) => void // 成功回调，入参接口返回数据
  onError?: (error: any, data?: RequestVo) => void // 失败回调，入参第一个接口失败异常，第二个接口返回数据
}

const commonFn = async ({ method, url, data, options }: { method?: 'GET' | 'POST'; url: string; data?: any; options?: OptionsVo }) => {
  const { returnAll, errorToast, errorMsg, loading, onSuccess, onError } = options || {}
  try {
    if (loading) ActivityIndicator.showLoading()
    const requestData = await commonRequest({ url, data, method })
    if (returnAll) return requestData // 全量数据返回，使用方自行判断成功与否
    if (requestData?.code === 0) {
      onSuccess && onSuccess(requestData)
      return isJSON(requestData?.data) || requestData?.data // 默认只返回成功数据
    } else {
      const showMessage = errorMsg || requestData?.message || i18nClient.getText('keetamember_system_error', 'There was a system issue. Please try again later.')
      // 失败中止进程
      if (onError) {
        onError(null, requestData)
        if (errorToast) Toast.show(showMessage, 2)
      } else if (errorToast) Toast.show(showMessage, 2)
      throw new Error('')
    }
  } catch (error) {
    // 失败中止进程
    if (onError) {
      onError(error)
      if (errorToast) Toast.show(errorMsg || 'system exception', 2)
    } else if (errorToast) Toast.show(errorMsg || 'system exception', 2)
    throw error
  } finally {
    if (loading) ActivityIndicator.hideLoading()
  }
}

// get请求
const get = async (url: string, data?: any, options?: OptionsVo) => commonFn({ url, data, options })

// post请求
const post = async (url: string, data?: any, options?: OptionsVo) => commonFn({ method: 'POST', url, data, options })

export { get, post }
export type { RequestVo }
